<!-- sidebar -->
<div class="text-white space-y-6 hidden md:block sticky top-0 h-dvh"
    [ngClass]="tabOpen?'w-max':'w-fit'">
    <ng-container [ngTemplateOutlet]="tabOpen ? openTab : closedTab" ></ng-container>
</div>
<router-outlet></router-outlet>

<ng-template #closedTab >
    <div class="bg-primary w-full h-full transition-all animate-fade-right animate-ease-in-out duration-700 p-4 shadow-md">
        <img src="assets/images/icons/menu-grid.svg" alt="menu" class=" w-8 cursor-pointer"
             (click)="toggleTab()"/>
    </div>
</ng-template>

<ng-template #openTab>
    <div class="bg-primary w-full h-full transition-all animate-fade-right duration-700">
        <div class="p-4 space-y-6">
            <div class="float-end" (click)="toggleTab()">
                <img src="assets/images/icons/close.svg" alt="close" class="w-8 cursor-pointer"/>
            </div>
            <div>
                <h3 class="capitalize font-bold text-lg">
                    {{ "DASHBOARD.LOGIN_USER" | translate }}
                </h3>
                <h4>
                    {{user()?.email}}
                </h4>
            </div>

            <button class="bg-secondary w-max text-white text-lg font-bold p-2 rounded-md first-letter:capitalize hover:bg-secondary-600 text-nowrap flex gap-2"
                    routerLink="/">
                <label class="first-letter:capitalize"> {{ "DASHBOARD.TO_CONFIGURATOR" | translate }} </label>
                <img src="assets/images/icons/arrow-right.svg" alt="arrow right" class="" width="18"/>
            </button>
        </div>

        <hr class="my-8 h-px border-0 bg-gray-300 mx-4" />

        <ul class="text-xl text-nowrap font-bold text-start flex flex-col uppercase">
            @for (tab of tabs; track tab){
                <a [routerLink]="tab.link">
                    <li class="px-4 py-2 hover:bg-primary-600">
                            {{ ("DASHBOARD."+tab.title) | translate }}
                    </li>
                </a>
            }
        </ul>

        <hr class="my-8 h-px border-0 bg-gray-300 mx-4" />
    </div>

</ng-template>